<template>
  <transition name="fade">
    <div v-if="showWarning" class="modal-overlay">
      <form @submit.prevent="create" class="modal-container">
        <div class="modal-header bg-primary text-white">
          <p class="modal-title">{{ title }}</p>
          <div @click="close()" class="p-0 ml-2">
            <img
              class="close-icon cursor-pointer h-8 w-8"
              src="@/assets/icons/cross-white.png"
            />
          </div>
        </div>
        <div class="modal-body">
          <p class="message text-center text-lg">{{ message }}</p>
        </div>
        <div class="modal-footer">
          <button type="submit" class="confirm-button bg-primary text-white">
            Ok
          </button>
        </div>
        <div v-if="loading" class="loading-overlay">
          <loader class="center-h-v" />
        </div>
      </form>
    </div>
  </transition>
</template>

<script>
import Loader from "@/components/loader/loader.vue";
export default {
  name: "ActionWarning",
  props: ["showWarning", "setIsConfirmed", "message", "title"],
  components: { Loader },
  data() {
    return {
      loading: false,
    };
  },

  methods: {
    close() {
      this.$emit("close");
    },

    create() {
      this.setIsConfirmed("DELETE");
      this.close();
    },
  },
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  max-width: 80%;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  /* background: #333; */
  color: #fff;
}

.modal-title {
  font-size: 1.2rem;
  font-weight: bold;
}

.close-icon {
  cursor: pointer;
}

.modal-body {
  padding: 1.5rem;
  text-align: center;
}

.warning-icon {
  width: 40px;
  height: 40px;
  margin-bottom: 1rem;
}

.message {
  font-size: 1rem;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}

.confirm-button {
  color: #fff;
  padding: 0.5rem 1rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1100;
}
</style>
